// isSameDay from date-fns doesn't consider local timezone, use this instead
export const isSameDayLocal = (date1: Date, date2: Date): boolean => {
  if (!date1 || !date2) { return false; };
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const dateString1 = date1.toLocaleDateString(undefined, options);
  const dateString2 = date2.toLocaleDateString(undefined, options);

  return dateString1 === dateString2;
};
